export default defineAppConfig({
  bookingLayer: {},
});

declare module "@nuxt/schema" {
  interface AppConfigInput {
    bookingLayer?: {};
  }
}
